import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import { DirectorConstants } from '../app.constants'
import { AppUtilityService } from 'src/app/common/app-utility.service'
import {environment, countryCodes} from 'src/environments/environment.prod'
declare var $: any;

@Component({
  selector: 'app-director-details',
  templateUrl: './director-details.component.html',
  styleUrls: ['./director-details.component.scss']
})
export class DirectorDetailsComponent implements OnInit {

  directorDetails: FormGroup;
  constitution;
  isAddtionalDirectorPresent: boolean = false;
  isShowingOfficeDetails: boolean = false;
  isSoleProprietor: boolean = false;
  isPatnership: boolean = false;
  isSdnBhd: boolean = false;
  isEditMode: boolean = false;
  refCCDL: any;
  refSCDL: any;
  isSalesAssisted: boolean = false;
  postalCodeMaxLength = '5';
  postalCodeMinLength = '5'
  firstDirectorMaxLengthMobileNo: Number = 48
  firstDirectorMinLengthMobileNo: Number = 1
  secondDirectorMaxLengthMobileNo: Number = 48
  secondDirectorMinLengthMobileNo: Number = 1
  BBMDirectorMaxLengthMobileNo: Number = 48
  BBMDirectorMinLengthMobileNo: Number = 1
  isValidNRIC:boolean = true;
  isCorrectionRequired: boolean= false;
  mobileNumberPattern = this.AppUtility.mobileNumberPattern('60');
  firstDirectorMobileNumberPattern = this.mobileNumberPattern;
  secondDirectorMobileNumberPattern = this.mobileNumberPattern;
  BBMMobileNumberPattern = this.mobileNumberPattern;
  CountryCodes : any[];
   // (Begin) Added by CJT / Code by Sonny 09Jul2020
  //change request for SIR 9 and 14 --- start
  // find word 'onPaste="return false" onDrop="return false" onDrag="return false"' for relevant change in HTML
  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue) {

    if (elemValue.target.id === 'mobile_mandatory' || elemValue.target.id === 'director_mobile_2' || elemValue.target.id === 'director_mobile') {
      return this.AppUtility.mobileNumberValidation(elemValue.key)
    } else if (String(elemValue.target.id).endsWith("postcode") || String(elemValue.target.name).endsWith("nric") || elemValue.target.name === 'ref_code') {
      return this.AppUtility.numericOnlyValidation(elemValue.key)
    } else if (elemValue.target.type === 'text' || elemValue.target.type === 'email') {
      return this.AppUtility.characterValidation(elemValue.key)
    }
  }
  // (End) CJT / Sonny 09Jul2020

  constructor(public router: Router,
    private formBuilder: FormBuilder,
    private connectRestService: ConnectRestService,
    private activatedRoute: ActivatedRoute,
    public appComp: AppComponent,
    private AppUtility: AppUtilityService) {

  }

  ngOnInit() {
    // sessionStorage.setItem('constitution', 'D');
    this.constitution = sessionStorage.getItem('constitution');
    this.directorDetails = this.formBuilder.group({
      directorName1: ['', Validators.required],
      directorCountryCode1: ['60'],
      directorMobile1: ['', [Validators.required, Validators.pattern(this.firstDirectorMobileNumberPattern)]],
      directorEmail1: ['', [Validators.required, Validators.pattern(environment.emailPatternHTML5)]],
      directorNRIC1: ['', Validators.required],
      isUltimateOwner1: [true],
      directorName2: [''],
      directorCountryCode2: ['60'],
      directorMobile2: [''],
      directorEmail2: ['', Validators.pattern(environment.emailPatternHTML5)],
      directorNRIC2: [''],
      isUltimateOwner2: [true],
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      addressLine3: [''],
      addressLine4: [''],
      countryCode: ['', Validators.required],
      postalCode: ['', Validators.required],
      stateCode: ['', Validators.required],
      otherUltimateOwner: ['', Validators.required],
      officeMobile: [''],
      officeCountryCode: ['60'],
      officeEmail: ['', Validators.pattern(environment.emailPatternHTML5)],
      officeRefNum: [''],
      retrievableEmail: ['', Validators.required]

    });

    this.isSoleProprietor = this.constitution === DirectorConstants.SOLEPROPRIETOR ? true : false;
    this.isPatnership = this.constitution === DirectorConstants.PARTNERSHIP ? true : false;
    this.isSdnBhd = this.constitution === DirectorConstants.SDNBHD ? true : false;
    if (this.isPatnership) {
      $("#second-director-cont").removeClass("hidden");
      this.isAddtionalDirectorPresent = true;
      this.addAdditonalDirectorValidators();
    }

    if (this.isSoleProprietor){
      $(".chk-cont").css("opacity", ".4");
    }
    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    const _this = this;
    // console.log($("#countryCode").val());
    // console.log($("#countryCode_2").val());
    // console.log($("#countryCode_m").val());


    /*
       *** removed by Sonny
       *** created centralized fucntion for resuable components
 
 
     $("#countryCode").change(function () {
       $("#director_mobile").val("");
       var len = $(this).val().length;
       var max_length = 50-len;
      // console.log(max_length)
       if ($("#countryCode").val() == "60") {
         $("#director_mobile").attr('maxlength', 48);
         $("#director_mobile").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
       }
       else {
         $("#director_mobile").attr('maxlength', max_length);
         $("#director_mobile").removeAttr('pattern');
       }
     });
 
 
     $("#countryCode_2").change(function () {
       $("#director_mobile_2").val("");
       var len = $(this).val().length;
       var max_length = 50-len;
      // console.log(max_length)
       if ($("#countryCode_2").val() == "60") {
         $("#director_mobile_2").attr('maxlength', 48);
         $("#director_mobile_2").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
       }
       else {
         $("#director_mobile_2").attr('maxlength', max_length);
         $("#director_mobile_2").removeAttr('pattern');
       }
     });
   
 
     $("#countryCode_m").change(function () {
       $("#mobile_mandatory").val("");
       var len = $(this).val().length;
       var max_length = 50-len;
      // console.log(max_length)
       if ($("#countryCode_m").val() == "60") {
         $("#mobile_mandatory").attr('maxlength', 48);
         $("#mobile_mandatory").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
       }
       else {
         $("#mobile_mandatory").attr('maxlength', max_length);
         $("#mobile_mandatory").removeAttr('pattern');
       }
     });
     // $(document).change(function () { $("#obaoform").valid();})
     */

    $(document).ready(function () {

      $("input").focus(function () {
        if (this.id != 'mobile_mandatory' && this.id != 'director_mobile_2' && this.id != 'director_mobile') {
          $('#mobile_mandatory').blur()
          $('#director_mobile_2').blur()
          $('#director_mobile').blur()
        }
      })

      /* DCI update (29 June 2020): Add function to change maxlength of postcode*/
      $("#selCountry").change(function () {
        if ($("#selCountry").val() == "MY") {
          $("#director_postcode").attr("maxlength", 5);
          $("#director_postcode").attr("minlength", 5);
        } else {
          $("#director_postcode").attr("maxlength", 9);
          $("#director_postcode").attr("minlength", 1);
        }
        $("#obaoform").validate().element("#director_postcode");
      });


      $("#mailing_address_check").click(function () {
        if ($(this).is(":checked")) {
          $(".mailing_address").hide();
        } else {
          $(".mailing_address").show();
        }
      });

      $(".btn-add").click(function () {
        $("#second-director-cont").removeClass("hidden");
        $("#add-cont").hide();
        _this.isAddtionalDirectorPresent = true;
      });

      $(".btn-remove").click(function () {
        $("#second-director-cont").addClass("hidden");
        $("#add-cont").show();
        _this.isAddtionalDirectorPresent = false;
      });

      $("#selCountry").change(function () {
        var countryCode = $("#selCountry").val()
        if (countryCode == "MY") {
          //   console.log(countryCode);
          $("#state-sec").show();
          $("#director_address_4").addClass("hidden");
        } else {
          $("#state-sec").hide();
          $("#director_address_4").removeClass("hidden");
          //   console.log(countryCode);
        }
      });

      /*   $("#indvName").click(function () {
          if ($("#indvName select").val() == "none-the-above") {
            $(".indvEmail").addClass("hidden");
            $(".nonethe-above").removeClass("hidden");
            _this.isShowingOfficeDetails = true;
          }
  
          else if ($("#indvName select").val() == "first-director-name") {
            $(".nonethe-above").addClass("hidden");
            $(".indvEmail").removeClass("hidden");
            _this.isShowingOfficeDetails = false;
          }
          else {
            $(".indvEmail").addClass("hidden");
            $(".nonethe-above").addClass("hidden");
          }
        }); */

      $(".form-check-input").change(function () {

        if (_this.isSoleProprietor || (_this.isSdnBhd && !_this.isAddtionalDirectorPresent)) {

          if ($("#ownerCheck").prop("checked") === false) {
            $("#rbYes").prop("checked", true);
            $("#rbNo").prop("disabled", true);
            $(".radio-item").css("opacity", ".4");
          } else {
            $("#rbNo").prop("disabled", false);
            $(".radio-item").css("opacity", "1");

          }
        } else if (($("#ownerCheck").prop("checked") === false) && ($("#ownerCheck_2").prop("checked") === false)) {
          $("#rbYes").prop("checked", true);
          $("#rbNo").prop("disabled", true);
          $(".radio-item").css("opacity", ".4");
        } else {
          $("#rbNo").prop("disabled", false);
          $(".radio-item").css("opacity", "1")

        }
        // $("#btn-next").prop("disabled", false);
      });


      /* DCI update (16 June 2020): Add code for country code*/
      var countryCode_1 = $("#countryCode");
      var numberPhone = $("#director_mobile");
      var countryCode_2 = $("#countryCode_2");
      var numberPhone_2 = $("#director_mobile_2");
      var countryCode_m = $("#countryCode_m");
      var numberPhone_m = $("#mobile_mandatory");

      /*
      *** removed by Sonny
      *** created centralized fucntion for resuable components

      $("#countryCode").change(function () {
        var len = $(this).val().length;
        var max_length = 50-len;
        $("#director_mobile").val("");
        if ($("#countryCode").val() == "60") {
          $("#director_mobile").attr('maxlength', 10);
          $("#director_mobile").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
        }
        else {
          $("#director_mobile").attr('maxlength', max_length);
          $("#director_mobile").removeAttr('pattern');
        }
      });

      $("#director_mobile").change(function () {
        if ($("#countryCode").val() == "60") {
          $("#director_mobile").attr('maxlength', 10);
          $("#director_mobile").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
        }
      });

      $("#countryCode_2").change(function () {
        var len = $(this).val().length;
        var max_length = 50-len;
        $("#director_mobile_2").val("");
        if ($("#countryCode_2").val() == "60") {
          $("#director_mobile_2").attr('maxlength', 10);
          $("#director_mobile_2").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
        }
        else {
          $("#director_mobile_2").attr('maxlength', max_length);
          $("#director_mobile_2").removeAttr('pattern');
        }
      });

      $("#director_mobile_2").change(function () {
        if ($("#countryCode_2").val() == "60") {
          $("#director_mobile_2").attr('maxlength', 10);
          $("#director_mobile_2").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
        }
      });


      $("#countryCode_m").change(function () {
        var len = $(this).val().length;
        var max_length = 50-len;
        $("#mobile_mandatory").val("");
        if ($("#countryCode_m").val() == "60") {
          $("#mobile_mandatory").attr('maxlength', 10);
          $("#mobile_mandatory").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
        }
        else {
          $("#mobile_mandatory").attr('maxlength', max_length);
          $("#mobile_mandatory").removeAttr('pattern');
        }
      });

      $("#mobile_mandatory").change(function () {
        if ($("#countryCode_m").val() == "60") {
          $("#mobile_mandatory").attr('maxlength', 10);
          $("#mobile_mandatory").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
        }
      });


      numberPhone.keyup(function () {
        $("#director_mobile_number_hidden").val(countryCode_1.val() + numberPhone.val());
      //  console.log("D1:" + $("#director_mobile_number_hidden").val());
      });

      numberPhone_2.keyup(function () {
        $("#director_mobile_2_hidden").val(countryCode_2.val() + numberPhone_2.val());
       // console.log("D2:" + $("#director_mobile_2_hidden").val());
      });

      numberPhone_m.keyup(function () {
        $("#mobile_mandatory_hidden").val(countryCode_m.val() + numberPhone_m.val());
      //  console.log("M:" + $("#mobile_mandatory_hidden").val());
      });
     */

      //DCI update (15/7/2020): Disable keypress enter or other to navigate page
      $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
          return false;
        }
      })

      // this is for radio button to be validate
      $.validator.setDefaults({
        ignore: ".ignore"
      });
      var validator = $("#obaoform").validate({
        rules: {
          director_name: {
            required: true
          },
          director_nric: {
            required: true,
            number: true

          },
          director_email: {
            required: true,
            email:true
          },
          director_mobile: {
            required: true,
            number: true
          },
          director_name_2: {
            required: {
              depends: () => {
                if (_this.isAddtionalDirectorPresent) {
                  return true;
                } else {
                  return false;
                }
              }
            }
          },
          // director_nric_2: {
          //   required: {
          //     depends: () => {
          //       if (_this.isAddtionalDirectorPresent) {
          //         return true;
          //       } else {
          //         return false;
          //       }
          //     }
          //   },
          //   number: true
          // },
          director_email_2: {
            required: {
              depends: () => {
                if (_this.isAddtionalDirectorPresent) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            email:true
          },
          director_mobile_2: {
            required: {
              depends: () => {
                if (_this.isAddtionalDirectorPresent) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            number: true
          },

          director_address_1: {
            required: true
          },
          selState: {
            required:
            {
              depends: function () {
                if ($("#selCountry").val() == "MY") {
                  return true;
                } else {
                  return false;
                }

              }
            }
          },
          selCountry: {
            required: true
          },
          indvName: {
            required: true
          },
          director_postcode: {
            required: true,
            number: true
          },
          opt_radio: {
            required: true
          },
          ref_code: {
            required: {
              depends: () => {
                if (_this.isShowingOfficeDetails) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            number: true
          },
          email_mandatory: {
            required: {
              depends: () => {
                if (_this.isShowingOfficeDetails) {
                  return true;
                } else {
                  return false;
                }
              }
            }
          },
          mobile_mandatory: {
            required: {
              depends: () => {
                if (_this.isShowingOfficeDetails) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            number: true
          }
        },
        messages: {
          director_name: {
            required: "Please enter name"
          },
          director_nric: {
            required: "Please enter identification number",
            number: "Identification number must be numeric",
            pattern: "Please enter valid format"
          },
          director_email: {
            required: "Please enter email",
            email: "Please enter valid email address",
            pattern: "Please enter valid email address"
          },
          director_mobile: {
            required: "Please enter mobile number",
            number: "Please enter a valid number",
            pattern: "Please enter valid format"

          },
          director_name_2: {
            required: "Please enter name"
          },
          director_nric_2: {
            required: "Please enter identification number",
            number: "Identification number must be numeric"
          },
          director_email_2: {
            required: "Please enter email",
            email: "Please enter valid email address",
            pattern: "Please enter valid email address"

          },
          director_mobile_2: {
            required: "Please enter mobile number",
            number: "Please enter a valid number",
            pattern: "Please enter valid format"
          },
          director_address_1: {
            required: "Please enter residential address",
          },
          director_postcode: {
            required: "Please enter postcode number",
            number: "Postcode should be numeric",
            maxlength: "Postcode should be no more than {0} numeric characters.",
            minlength: "Please enter at least {0} numeric characters."
          },
          opt_radio: {
            required: "Please select an option"
          },
          ref_code: {
            required: "Please enter reference code",
            number: "Reference code should be numeric"
          },
          email_mandatory: {
            required: "Please enter email",
            email: "Please enter valid email address",
            pattern: "Please enter valid email address"
          },
          mobile_mandatory: {
            required: "Please enter mobile number",
            number: "Please enter a valid number",
            pattern: "Please enter valid format"
          },
          selState: {
            required: "Please select a state"
          },
          selCountry: {
            required: "Please select a country"
          },
          indvName: {
            required: "Please select an option"
          }
        },
        errorPlacement: function (error, element) {
          if (element.attr("name") == "director_name") {
            error.appendTo("#director_name_error_container");
          }
          if (element.attr("name") == "director_nric") {
            error.appendTo("#director_nric_error_container");
          }
          if (element.attr("name") == "director_email") {
            error.appendTo("#director_email_error_container");
          }
          if (element.attr("name") == "director_mobile") {
            error.appendTo("#director_mobile_error_container");
          }
          // if (sessionStorage.getItem('constitution') === 'B') {
          if (element.attr("name") == "director_name_2") {
            error.appendTo("#director_name_2_error_container");
          }

          // if (element.attr("name") == "director_nric_2") {
          //   error.appendTo("#director_nric_2_error_container");
          // }
          if (element.attr("name") == "director_email_2") {
            error.appendTo("#director_email_2_error_container");
          }

          if (element.attr("name") == "director_mobile_2") {
            error.appendTo("#director_mobile_2_error_container");
          }
          // }
          if (element.attr("name") == "director_address_1") {
            error.appendTo("#director_address_1_error_container");
          }
          if (element.attr("name") == "selState") {
            error.appendTo("#selState_error_container");
          }
          if (element.attr("name") == "selCountry") {
            error.appendTo("#selCountry_error_container");
          }
          if (element.attr("name") == "director_postcode") {
            error.appendTo("#director_postcode_error_container");
          }
          if (element.attr("name") == "opt_radio") {
            error.appendTo("#opt_radio_error_container");
          }
          if (element.attr("name") == "ref_code") {
            error.appendTo("#ref_code_error_container");
          }
          if (element.attr("name") == "email_mandatory") {
            error.appendTo("#email_mandatory_error_container");
          }
          if (element.attr("name") == "mobile_mandatory") {
            error.appendTo("#mobile_mandatory_error_container");
          }
          if (element.attr("name") == "indvName") {
            error.appendTo("#indvName_error_container");
          }
        },
        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }

      });

    });
    this.callDropdownValues().then(this.appComp.loadCustomDropdown);
    const requestId = 'R0020';
    const flowId = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
    this.getResponse(flowId, requestId);
  }

  async callDropdownValues() {
    this.refSCDL = JSON.parse(sessionStorage.RefSCDL);
    this.refCCDL = JSON.parse(sessionStorage.RefCCDL);
    this.CountryCodes = countryCodes;
}

  // method to call retrieval api
  public async getResponse(flowId, requestId) {
    const responseData = await this.connectRestService.connectRest(flowId, requestId, '');
    if (responseData.Status === 'Success') {
      this.setFormData(responseData, flowId);
      if (requestId == "R0020" && responseData['SalesAssisted']) {
        var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader)
        if (ServiceHeader.Flow) {
          this.isSalesAssisted = ServiceHeader.Flow == "1" && responseData['SalesAssisted'] == true ? true : false
        }
      }
    } else {
      //  console.log("Server Response: " + responseData.Status);
    }
    // Added for Edit Mode
    if (this.isEditMode) {
      $("#indvName").prop('disabled', true);
    }

    this.onCountryCodeChange({value:this.directorDetails.value.directorCountryCode1, id:'countryCode'})
  }

  // method to set formdata during pageload
  public setFormData(data, flowId) {
    if (flowId === '' || flowId === undefined) {
      this.directorDetails.controls['directorName1'].setValue(data.ApplicantName);
      this.directorDetails.controls['directorEmail1'].setValue(data.EmailAddress);
      let mobileNum = data.mobileNumber;
      this.directorDetails.controls['directorMobile1'].setValue(mobileNum.split('-')[1]);
      this.directorDetails.controls['directorCountryCode1'].setValue(mobileNum.split('-')[0]);
      this.directorDetails.controls['retrievableEmail'].setValue('first-director-name');
      //set state default value to W.P Kuala Lumpur
      //Any changes on the back end need to change this value
      //Added by Sonny
      this.directorDetails.controls['stateCode'].setValue(environment.stateCode);
      this.directorDetails.controls['countryCode'].setValue(environment.countryCode);
      // Added By CJT 15Jul2020 for Mobile Number Pattern
      this.firstDirectorMobileNumberPattern = this.AppUtility.mobileNumberPattern(this.directorDetails.value.directorCountryCode1);

      $(".nonethe-above").addClass("hidden");
      $(".indvEmail").removeClass("hidden");
    } else {
      this.isCorrectionRequired = data.IsCorrectionRequried;
      this.directorDetails.controls['directorName1'].setValue(data.ApplicantList[0].Name);
      for (let contact of data.ApplicantList[0].ContactInfo) {
        if (contact.Type === 'EM') {
          this.directorDetails.controls['directorEmail1'].setValue(contact.Value)
        } else if (contact.Type === 'PM') {
          let mobileNum = contact.Value;
          this.directorDetails.controls['directorMobile1'].setValue(mobileNum.split('-')[1]);
          this.directorDetails.controls['directorCountryCode1'].setValue(mobileNum.split('-')[0]);
        }

      }
      this.directorDetails.controls['directorNRIC1'].setValue(data.ApplicantList[0].NRIC);
      this.directorDetails.controls['isUltimateOwner1'].setValue(data.ApplicantList[0].UltimateOwner);
      if(this.isSoleProprietor){
        this.directorDetails.controls['isUltimateOwner1'].setValue(true);
      }
      this.directorDetails.controls['addressLine1'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine1);
      this.directorDetails.controls['addressLine2'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine2);
      this.directorDetails.controls['addressLine3'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine3);
      this.directorDetails.controls['addressLine4'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine4);
      this.directorDetails.controls['countryCode'].setValue(data.ApplicantList[0].AddressInfo[0].CountryCode);
      this.directorDetails.controls['postalCode'].setValue(data.ApplicantList[0].AddressInfo[0].PostalCode);
      this.directorDetails.controls['stateCode'].setValue(data.ApplicantList[0].AddressInfo[0].StateCode);
      if (data.ApplicantList[0].AddressInfo[0].CountryCode === DirectorConstants.MALAYSIA) {
        this.directorDetails.controls['addressLine4'].setValue('');
      } else {
        this.directorDetails.controls['stateCode'].setValue('');
        this.clearStateValidators();
        this.postalCodeMaxLength = '9';
        this.postalCodeMinLength = '1'
        $("#state-sec").hide();
        $("#director_address_4").removeClass("hidden");
      }

      if (data.ApplicantList[1] && data.ApplicantList[1].Name !== '') {
        $("#second-director-cont").removeClass("hidden");
        $("#add-cont").hide();
        this.isAddtionalDirectorPresent = true;
        this.directorDetails.controls['directorName2'].setValue(data.ApplicantList[1].Name);
        for (let contact of data.ApplicantList[1].ContactInfo) {
          if (contact.Type === 'EM') {
            this.directorDetails.controls['directorEmail2'].setValue(contact.Value)
          } else if (contact.Type === 'PM') {
            let mobileNum = contact.Value;
            this.directorDetails.controls['directorMobile2'].setValue(mobileNum.split('-')[1]);
            this.directorDetails.controls['directorCountryCode2'].setValue(mobileNum.split('-')[0]);
          }

        }
        
        this.addAdditonalDirectorValidators();
        this.directorDetails.controls['isUltimateOwner2'].setValue(data.ApplicantList[1].UltimateOwner);
      }

      this.directorDetails.controls['otherUltimateOwner'].setValue(
        data.CompanyInfo.OtherUltimateOwner ? 'Y' : 'N');

      const flowId = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
      if (flowId === '1') {
        this.directorDetails.controls['retrievableEmail'].setValue('first-director-name')
        $(".nonethe-above").addClass("hidden");
        $(".indvEmail").removeClass("hidden");
      } else if (data.OfficerInfo && data.OfficerInfo.ReferenceNumber !== '') {
        $(".indvEmail").addClass("hidden");
        $(".nonethe-above").removeClass("hidden");
        this.isShowingOfficeDetails = true;
        this.directorDetails.controls['retrievableEmail'].setValue('none-the-above')
        for (let contact of data.OfficerInfo.ContactInfo) {
          if (contact.Type === 'EM') {
            this.directorDetails.controls['officeEmail'].setValue(contact.Value)
          } else if (contact.Type === 'PM') {
            let mobileNum = contact.Value;
            this.directorDetails.controls['officeMobile'].setValue(mobileNum.split('-')[1]);
            this.directorDetails.controls['officeCountryCode'].setValue(mobileNum.split('-')[0]);
          }

        }
        this.addOfficeValidators();
        this.directorDetails.controls['officeRefNum'].setValue(data.OfficerInfo.ReferenceNumber);
      }
      if (this.isSoleProprietor || (this.isSdnBhd && !this.isAddtionalDirectorPresent)) {
        if (this.directorDetails.value.isUltimateOwner1 !== true) {
          $("#rbNo").prop("disabled", true);
        }
      } else if (this.isAddtionalDirectorPresent) {
        if (this.directorDetails.value.isUltimateOwner1 !== true && this.directorDetails.value.isUltimateOwner2 !== true) {
          $("#rbNo").prop("disabled", true);
        }

      }

    }

  }

  // method to reset second director details
  public removeAdditonalDirector() {
    this.directorDetails.controls['directorName2'].setValue('');
    this.directorDetails.controls['directorMobile2'].setValue('');
    this.directorDetails.controls['directorEmail2'].setValue('');
    // this.directorDetails.controls['directorNRIC2'].setValue('');
    this.directorDetails.controls['isUltimateOwner2'].setValue(true);
    this.clearAdditonalDirectorValidators();
    if (!this.directorDetails.value.isUltimateOwner1) {
      this.directorDetails.controls['otherUltimateOwner'].setValue('Y');
      $("#rbNo").prop("disabled", true);
    }
  }

  public addAdditonalDirector() {
    this.addAdditonalDirectorValidators();
    $("#rbNo").prop("disabled", false);
    $(".radio-item").css("opacity", "1")
  }

  public clearAdditonalDirectorValidators() {
    this.directorDetails.controls['directorName2'].clearValidators();
    this.directorDetails.controls['directorName2'].updateValueAndValidity();
    this.directorDetails.controls['directorMobile2'].clearValidators();
    this.directorDetails.controls['directorMobile2'].updateValueAndValidity();
    this.directorDetails.controls['directorEmail2'].clearValidators();
    this.directorDetails.controls['directorEmail2'].updateValueAndValidity();
  }

  public addAdditonalDirectorValidators(){    
      // Added By CJT 15Jul2020 for Mobile Number Pattern
    this.onCountryCodeChange({value:this.directorDetails.value.directorCountryCode2, id:'countryCode_2'})
    this.secondDirectorMobileNumberPattern = this.AppUtility.mobileNumberPattern(this.directorDetails.value.directorCountryCode2);
    this.directorDetails.controls['directorName2'].setValidators([Validators.required]);
    this.directorDetails.controls['directorName2'].updateValueAndValidity();
    this.directorDetails.controls['directorMobile2'].setValidators([Validators.required, Validators.pattern(this.secondDirectorMobileNumberPattern)]);
    this.directorDetails.controls['directorMobile2'].updateValueAndValidity();
    this.directorDetails.controls['directorEmail2'].setValidators([Validators.required, Validators.pattern(environment.emailPatternHTML5)]);
    this.directorDetails.controls['directorEmail2'].updateValueAndValidity();
  }
  // method to reset ref num related details
  public retrievableEmailChange(event) {
    if (event.target.value === 'none-the-above') {
      this.addOfficeValidators();
      $(".indvEmail").addClass("hidden");
      $(".nonethe-above").removeClass("hidden");
      this.isShowingOfficeDetails = true;
    } else {
      this.directorDetails.controls['officeMobile'].setValue('');
      this.directorDetails.controls['officeEmail'].setValue('');
      this.directorDetails.controls['officeRefNum'].setValue('');
      this.clearOfficeValidators();
      $(".nonethe-above").addClass("hidden");
      $(".indvEmail").removeClass("hidden");
      this.isShowingOfficeDetails = false;
    }
  }

  public addOfficeValidators(){
    this.onCountryCodeChange({value:this.directorDetails.value.officeCountryCode, id:'countryCode_m'})
    // Added By CJT 15Jul2020 for Mobile Number Pattern
    this.BBMMobileNumberPattern = this.AppUtility.mobileNumberPattern(this.directorDetails.value.officeCountryCode);
    this.directorDetails.get("officeMobile").setValidators([Validators.required,Validators.pattern(this.BBMMobileNumberPattern)]);
    this.directorDetails.get("officeMobile").updateValueAndValidity();
    this.directorDetails.get("officeEmail").setValidators([Validators.required, Validators.pattern(environment.emailPatternHTML5)]);
    this.directorDetails.get("officeEmail").updateValueAndValidity();
    this.directorDetails.get("officeRefNum").setValidators([Validators.required]);
    this.directorDetails.get("officeRefNum").updateValueAndValidity();
  }

  public clearOfficeValidators() {
    this.directorDetails.get("officeMobile").clearValidators();
    this.directorDetails.get("officeMobile").updateValueAndValidity();
    this.directorDetails.get("officeEmail").clearValidators();
    this.directorDetails.get("officeEmail").updateValueAndValidity();
    this.directorDetails.get("officeRefNum").clearValidators();
    this.directorDetails.get("officeRefNum").updateValueAndValidity();
  }

  public isFirstOwnerChecked(event) {
    if (this.isSoleProprietor || (this.isSdnBhd && !this.isAddtionalDirectorPresent) || !this.directorDetails.value.isUltimateOwner2) {
      this.directorDetails.controls['otherUltimateOwner'].setValue('Y');
    } else {
      // this.directorDetails.controls['otherUltimateOwner'].setValue('');
    }
  }

  public isSecondOwnerChecked(event) {
    if (!this.directorDetails.value.isUltimateOwner1) {
      this.directorDetails.controls['otherUltimateOwner'].setValue('Y');
    } else {
      // this.directorDetails.controls['otherUltimateOwner'].setValue('');
    }
  }

  public countryChange(event) {
    if (event.target.value === DirectorConstants.MALAYSIA) {
      this.directorDetails.controls['addressLine4'].setValue('');
      this.directorDetails.get("stateCode").setValidators([Validators.required]);;
      this.directorDetails.get("stateCode").updateValueAndValidity();
      this.postalCodeMaxLength = '5';
      this.postalCodeMinLength = '5'
    } else {
      this.directorDetails.controls['stateCode'].setValue('');
      this.clearStateValidators();
      this.postalCodeMaxLength = '9';
      this.postalCodeMinLength = '1';
    }
  }

  public clearStateValidators() {
    this.directorDetails.get("stateCode").clearValidators();
    this.directorDetails.get("stateCode").updateValueAndValidity();
  }

  validateChar(event){
    var value = event.target.value;
    var control = event.target.getAttribute('formcontrolname');
    if(!this.AppUtility.stringValidation(value)){
      this.directorDetails.get(control).setValue(this.AppUtility.filterInvalidCharacters(value));
    }
  }
  // method to submit the form
  public onSubmit() {
    // if(this.constitution === 'B' &&  this.directorDetails.controls['directorName2'].value === ''){
    //   $("#second-director-cont").removeClass("hidden");
    //   $("#add-cont").hide();
    // }


    if ($("#obaoform").valid()) {
      const serviceBody = {
        "ApplicantList": [{
          "AddressInfo": [{
            "AddressType": "H",
            "AddressLine1": this.directorDetails.value.addressLine1,
            "AddressLine2": this.directorDetails.value.addressLine2,
            "AddressLine3": this.directorDetails.value.addressLine3,
            "AddressLine4": this.directorDetails.value.addressLine4,
            "CountryCode": this.directorDetails.value.countryCode,
            "PostalCode": this.directorDetails.value.postalCode,
            "StateCode": this.directorDetails.value.stateCode,
          }
          ],
          "ContactInfo": [{
            "Type": "EM",
            "Value": this.directorDetails.value.directorEmail1
          }, {
            "Type": "PM",
            "Value": this.directorDetails.value.directorCountryCode1 + '-' + this.directorDetails.value.directorMobile1
          }
          ],
          "NRIC": this.directorDetails.value.directorNRIC1,
          "Name": this.directorDetails.value.directorName1,
          "UltimateOwner": this.directorDetails.value.isUltimateOwner1
        }, {
          "ContactInfo": [{
            "Type": "EM",
            "Value": this.directorDetails.value.directorEmail2
          }, {
            "Type": "PM",
            "Value": this.directorDetails.value.directorCountryCode2 + '-' + this.directorDetails.value.directorMobile2
          }
          ],
          "NRIC": '',
          "Name": this.directorDetails.value.directorName2,
          "UltimateOwner": this.directorDetails.value.isUltimateOwner2
        }
        ],
        "CompanyInfo": {
          "OtherUltimateOwner": this.directorDetails.value.otherUltimateOwner === 'N' ? false : true
        },
        "OfficerInfo": {
          "ContactInfo": [{
            "Type": "EM",
            "Value": this.directorDetails.value.officeEmail
          }, {
            "Type": "PM",
            "Value": this.directorDetails.value.officeCountryCode + '-' + this.directorDetails.value.officeMobile
          }
          ],
          "ReferenceNumber": this.directorDetails.value.officeRefNum
        }

      };
      // if (this.isSoleProprietor || (this.isSdnBhd && !this.isAddtionalDirectorPresent)) {
      //   serviceBody.ApplicantList = serviceBody.ApplicantList.splice(0,1);
      // }

      const firstDirector = {
        "NRIC": this.directorDetails.value.directorNRIC1,
        "Name": this.directorDetails.value.directorName1,
      }
      sessionStorage.setItem('firstDirector', JSON.stringify(firstDirector));
      this.restConnect(serviceBody);
    }
  }

  // method for update api
  public async restConnect(data) {
    const RequestID = 'S0020';
    const responseData = await this.connectRestService.connectRest(data, RequestID, '')
    if (responseData.Status === 'Success') {
      if (!this.isEditMode) {
        this.router.navigate(['/about-your-business']);
      } else {
        this.router.navigate(['/director-confirm']);
      }
    }
  }

  onCountryCodeChange(elemValue) {
    var respValue = this.AppUtility.mobileNumberMinMaxLength(elemValue.value)
    if (elemValue.id === 'countryCode') {
      this.firstDirectorMaxLengthMobileNo = respValue.max
      this.firstDirectorMinLengthMobileNo = respValue.min
      this.firstDirectorMobileNumberPattern = this.AppUtility.mobileNumberPattern(elemValue.value)
      // Added By CJT 15Jul2020 for Mobile Number Pattern
      this.directorDetails.get("directorMobile1").setValidators([Validators.required,Validators.pattern(this.firstDirectorMobileNumberPattern)]);
      this.directorDetails.get("directorMobile1").updateValueAndValidity();
    }else if(elemValue.id === 'countryCode_2'){
      this.secondDirectorMaxLengthMobileNo = respValue.max
      this.secondDirectorMinLengthMobileNo = respValue.min
      this.secondDirectorMobileNumberPattern = this.AppUtility.mobileNumberPattern(elemValue.value)
      // Added By CJT 15Jul2020 for Mobile Number Pattern
      this.directorDetails.get("directorMobile2").setValidators([Validators.required,Validators.pattern(this.secondDirectorMobileNumberPattern)]);
      this.directorDetails.get("directorMobile2").updateValueAndValidity();
    }else{
      this.BBMDirectorMaxLengthMobileNo = respValue.max
      this.BBMDirectorMinLengthMobileNo = respValue.min
      this.BBMMobileNumberPattern = this.AppUtility.mobileNumberPattern(elemValue.value)
      // Added By CJT 15Jul2020 for Mobile Number Pattern
      this.directorDetails.get("officeMobile").setValidators([Validators.required,Validators.pattern(this.BBMMobileNumberPattern)]);
      this.directorDetails.get("officeMobile").updateValueAndValidity();
    }
  }

  
  resetMobileValidation(elemValue){
    if(elemValue.id === 'countryCode' && this.directorDetails.controls['directorMobile1'].dirty){
      $('#director_mobile').valid()
    }else if(elemValue.id === 'countryCode_2' && this.directorDetails.controls['directorMobile2'].dirty){
      $('#director_mobile_2').valid()
    }else if(elemValue.id === 'countryCode_m' && this.directorDetails.controls['officeMobile'].dirty){
      $('#mobile_mandatory').valid()
    }
  }

  public validateNRIC(nric) {
    if (nric) {
      this.isValidNRIC = this.AppUtility.nricValidation(nric);
    }
  }


}
